import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './ButtonSelector.less';

const ButtonSelector = React.forwardRef((props, ref) => {
  const { children, onClick, value, active, className, secondary, ...rest } = props;

  return (
    <button
      {...rest}
      ref={ref}
      type="button"
      onClick={() => onClick(value)}
      className={cx('zola-ui__buttonSelector', { active, secondary }, className)}
    >
      {children}
    </button>
  );
});

ButtonSelector.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  className: PropTypes.string,
  secondary: PropTypes.bool,
};

ButtonSelector.defaultProps = {
  active: false,
  className: '',
  secondary: false,
  onClick: () => {},
};

export default ButtonSelector;



// WEBPACK FOOTER //
// ./src/components/common/zolaUI/ButtonSelector/ButtonSelector.jsx